import React from 'react'
import { View, TouchableOpacity, useWindowDimensions } from 'react-native'
import PropTypes from 'prop-types'

import ContentLoader, { Rect } from 'react-content-loader/native'

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components'
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import styles from './ButtonCard.Styles'

import Card from '../Card'

const Button = ({ icon, title, price, directionIcon, onPress, style, bundlesLoading }) => {

  const theme = useTheme()
  const width = useWindowDimensions().width
  return (
    <View style={style}>
      <TouchableOpacity onPress={() => onPress && onPress()} activeOpacity={0.6}>
        <Card style={styles.cardStyle} theme={theme}>
          {bundlesLoading ? <ContentLoader
            width={width - 78}
            height={30}
            backgroundColor={theme.colors.shimmerCenterColor}
            foregroundColor={theme.colors.shimmerEdgesColor}
          >
            <Rect x="0" y="0" rx="10" ry="10" width={30} height={30} />
            <Rect x="50" y="7" rx="5" ry="5" width={150} height={15} />
            <Rect x={width - 98} y="0" rx="8" ry="8" width={20} height={30} />
          </ContentLoader> : <>
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <Icon source={icon} size={32} style={{ marginRight: 20, resizeMode: 'contain' }} type="image" />
              <View>
                <VFText
                  i18nKey={title}
                  style={styles.titleText(theme)}
                />
                {price && <VFText
                  i18nKey={price}
                  style={styles.priceText(theme)}
                />}
              </View>
            </View>
            <Icon
              source={directionIcon}
              size={23}
              resizeMode="contain"
            />
          </>}
        </Card>
      </TouchableOpacity>
    </View>
  )
}
Button.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  price: PropTypes.string,
  directionIcon: PropTypes.string,
  onPress: PropTypes.func,
  style: PropTypes.object
}


export default Button